/**
 * AccountTable Component
 * 가상계좌 테이블
 */
import React from 'react';
import { VirtualAccount } from '../types/virtualAccount.types';

interface AccountTableProps {
    accounts: VirtualAccount[];
    loading: boolean;
}

const AccountTable: React.FC<AccountTableProps> = ({ accounts, loading }) => {
    const getBankName = (bankCd: string) => {
        const bankMap: { [key: string]: string } = {
            '002': 'KDB산업',
            '003': 'IBK기업',
            '004': 'KB국민',
            '007': '수협',
            '011': 'NH농협',
            '020': '우리',
            '023': 'SC제일',
            '027': '씨티',
            '031': '대구',
            '032': '부산',
            '034': '광주',
            '035': '제주',
            '037': '전북',
            '039': '경남',
            '081': '하나',
            '088': '신한',
            '089': 'K뱅크',
            '090': '카카오뱅크'
        };
        return bankMap[bankCd] || bankCd;
    };

    const getAccountType = (type: string | null) => {
        if (!type) return '-';
        return type === 'R' ? '라이더' : type === 'S' ? '협력사' : type;
    };

    const getAccountStatus = (status: string | null) => {
        if (!status) return '-';
        const statusMap: { [key: string]: string } = {
            '1': '정상',
            '2': '정지',
            '3': '해지'
        };
        return statusMap[status] || status;
    };

    const formatDateTime = (dateTime: any) => {
        if (!dateTime) return '-';

        // 배열 형식 [2025, 12, 4, 10, 9, 7]
        if (Array.isArray(dateTime) && dateTime.length >= 6) {
            const [year, month, day, hour, minute, second] = dateTime;
            return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')} ${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}:${String(second).padStart(2, '0')}`;
        }

        // 문자열 형식
        if (typeof dateTime === 'string') {
            return dateTime.replace('T', ' ').substring(0, 19);
        }

        return '-';
    };

    if (loading) {
        return (
            <div className="loading-container">
                <i className="fas fa-spinner fa-spin"></i>
                <p>데이터를 불러오는 중...</p>
            </div>
        );
    }

    if (!accounts || accounts.length === 0) {
        return (
            <div className="empty-state">
                <i className="fas fa-inbox"></i>
                <p>조회된 가상계좌가 없습니다</p>
            </div>
        );
    }

    return (
        <div className="table-container">
            <table className="data-table">
                <thead>
                    <tr>
                        <th>순번</th>
                        <th>은행명</th>
                        <th>계좌번호</th>
                        <th>예금주</th>
                        <th>계좌유형</th>
                        <th>협력사ID</th>
                        <th>라이더ID</th>
                        <th>수정일시</th>
                        <th>수정자</th>
                    </tr>
                </thead>
                <tbody>
                    {accounts.map((account) => (
                        <tr key={account.seqNo}>
                            <td>{account.seqNo}</td>
                            <td>{getBankName(account.bankCd)}</td>
                            <td>{account.acctNo}</td>
                            <td>{account.accName}</td>
                            <td>{getAccountType(account.acctType)}</td>
                            <td>{account.suppId || '-'}</td>
                            <td>{account.riderId || '-'}</td>
                            <td>{formatDateTime(account.updDate)}</td>
                            <td>{account.updUser || '-'}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default AccountTable;
